"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var DEBOUNCE_TIMEOUT = 500;
function useDebouncedState(props) {
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    debouncedState = _useState2[0],
    setDebouncedState = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    waiting = _useState4[0],
    setWaiting = _useState4[1];
  var timer;
  (0, _react.useEffect)(function () {
    // Clear the previous timer if it exists
    if (timer) {
      clearTimeout(timer);
    }

    // Set a new timer to update the state after DEBOUNCE_TIMEOUT
    timer = setTimeout(function () {
      setDebouncedState(props);
      setWaiting(false);
    }, DEBOUNCE_TIMEOUT);
    setWaiting(true);

    // Clean up the timer on unmount or when props change
    return function () {
      return clearTimeout(timer);
    };
  }, [props]);
  return {
    debouncedState: debouncedState,
    waiting: waiting
  };
}
var _default = useDebouncedState;
exports.default = _default;